export const canUserBet = userInfo =>
    userInfo.canBet ?? userInfo.canLinkTo.includes('bet');

// canBet must be truly false
export const canLinkToConsideringCanBet = (canBet, canLinkTo) =>
    canBet === false ? canLinkTo.filter(item => item !== 'bet') : canLinkTo;
